<div class="kirjaamattomatDeleteDiv" (dragenter)="onDragEnter($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
  <div class="delete-drop-text">Irroita tosite kirjauksesta pudottamalla se tähän.</div>
  <i class="delete-drop-icon fa fa-arrow-down"></i>
</div>

<mat-menu #naytettavaKuittiMenu="matMenu">
  <ng-template matMenuContent let-naytettavaKuitti="naytettavaKuitti">
    <app-menu-item-button (click)="avaaKuittiUudessaIkkunassa(naytettavaKuitti)" actionId="Avaa uudessa ikkunassa (näytettävä kuitti)">Avaa uudessa ikkunassa</app-menu-item-button>
    <app-menu-item-button [disabled]="!(naytettavaKirjausObservable | async)" (click)="liitaKuitti(naytettavaKuitti)" actionId="Liitä valittuna olevaan kirjaukseen (näytettävä kuitti)">Liitä valittuna olevaan kirjaukseen</app-menu-item-button>
    <app-menu-item-button (click)="lisaaKuittiJatkuviin(naytettavaKuitti)" actionId="Avasi dialogin: Lisää toistuviin tositteisiin (näytettävä kuitti)">Lisää toistuviin tositteisiin</app-menu-item-button>
    <app-menu-item-button (click)="lataaKuitti(naytettavaKuitti)" actionId="Lataa kuitti">Lataa tosite</app-menu-item-button>
    <app-menu-item-button (click)="tallennaKuittiHallintokansioon(naytettavaKuitti)" actionId="Tallenna kuitti hallintokansioon">Tallenna hallintokansioon</app-menu-item-button>
    <app-menu-item-button (click)="paivitaKuitinKorostus(naytettavaKuitti, !naytettavaKuitti?.kirjattavaKuitti?.korostettu)" actionId="Päivitä kuitin korostus">{{ !naytettavaKuitti.kirjattavaKuitti?.korostettu ? 'Korosta' : 'Poista korostus' }}</app-menu-item-button>
    @if (onkoDevaajaTaiItTukiTaiMuut | async) {
      <app-menu-item-button (click)="teeLuottokorttilaskustaKirjaukset(naytettavaKuitti)" actionId="Tee luottokorttilaskusta kirjaukset (näytettävä kuitti)">Tee luottokorttilaskusta kirjaukset</app-menu-item-button>
      @if (naytettavaKuitti?.kirjattavaKuitti?.lka) {
        <app-menu-item-button (click)="poistaLuottokorttilaskunLuomatKirjaukset(naytettavaKuitti)" actionId="Poista luottokorttilaskun luomat kirjaukset (näytettävä kuitti)">Poista tositteesta luodut kirjaukset</app-menu-item-button>
      }
    }
    <app-menu-item-button (click)="poistaKuitti(naytettavaKuitti)" actionId="Avasi dialogin: Haluatko varmasti poistaa kuitin">Poista</app-menu-item-button>
  </ng-template>
</mat-menu>

<mat-menu #naytettavaLaskuMenu="matMenu">
  <ng-template matMenuContent let-naytettavaLasku="naytettavaLasku">
    <app-menu-item-button (click)="avaaLaskuUudessaIkkunassa(naytettavaLasku)" actionId="Avaa uudessa ikkunassa (näytettävä lasku)">Avaa uudessa ikkunassa</app-menu-item-button>
    <app-menu-item-button [disabled]="!(naytettavaKirjausObservable | async)" (click)="liitaLasku(naytettavaLasku)" actionId="Liitä valittuna olevaan kirjaukseen (näytettävä lasku)">Liitä valittuna olevaan kirjaukseen</app-menu-item-button>
    <!-- <app-menu-item-button (click)="lisaaLaskuJatkuviin(naytettavaLasku)" actionId="Avasi dialogin: Lisää toistuviin tositteisiin">Lisää toistuviin tositteisiin</app-menu-item-button> -->
    <app-menu-item-button (click)="lataaLasku(naytettavaLasku)" actionId="Lataa lasku">Lataa tosite</app-menu-item-button>
    <app-menu-item-button (click)="tallennaLaskuHallintokansioon(naytettavaLasku)" actionId="Tallenna lasku hallintokansioon">Tallenna hallintokansioon</app-menu-item-button>
    <app-menu-item-button (click)="paivitaLaskunKorostus(naytettavaLasku, !naytettavaLasku?.kirjattavaLasku?.korostettu)" actionId="Päivitä laskun korostus">{{ !naytettavaLasku?.kirjattavaLasku?.korostettu ? 'Korosta' : 'Poista korostus' }}</app-menu-item-button>
    <app-menu-item-button (click)="poistaLasku(naytettavaLasku)" actionId="Avasi dialogin: Haluatko varmasti poistaa laskun">Poista</app-menu-item-button>
  </ng-template>
</mat-menu>

<mat-menu #naytettavaRaahattavaMenu="matMenu">
  <ng-template matMenuContent let-naytettavaRaahattava="naytettavaRaahattava">
    <app-menu-item-button (click)="avaaRaahattavaUudessaIkkunassa(naytettavaRaahattava)" actionId="Avaa uudessa ikkunassa (näytettävä lasku)">Avaa uudessa ikkunassa</app-menu-item-button>
    <app-menu-item-button [disabled]="!(naytettavaKirjausObservable | async)" (click)="liitaRaahattava(naytettavaRaahattava)" actionId="Liitä valittuna olevaan kirjaukseen (näytettävä raahattava)">Liitä valittuna olevaan kirjaukseen</app-menu-item-button>
    <app-menu-item-button (click)="lisaaRaahattavaJatkuviin(naytettavaRaahattava)" actionId="Avasi dialogin: Lisää toistuviin tositteisiin (näytettävä raahattava)">Lisää toistuviin tositteisiin</app-menu-item-button>
    <app-menu-item-button (click)="lataaRaahattava(naytettavaRaahattava)" actionId="Lataa raahattava">Lataa tosite</app-menu-item-button>
    <app-menu-item-button (click)="tallennaRaahattavaHallintokansioon(naytettavaRaahattava)" actionId="Tallenna raahattava hallintokansioon">Tallenna hallintokansioon</app-menu-item-button>
    <app-menu-item-button (click)="paivitaRaahattavanKorostus(naytettavaRaahattava, !naytettavaRaahattava?.raahattava?.ko)" actionId="Päivitä raahattavan korostus">{{ !naytettavaRaahattava?.raahattava?.ko ? 'Korosta' : 'Poista korostus' }}</app-menu-item-button>
    <app-menu-item-button (click)="poistaRaahattava(naytettavaRaahattava)" actionId="Avasi dialogin: Haluatko varmasti poistaa raahattavan">Poista</app-menu-item-button>
  </ng-template>
</mat-menu>

<mat-menu #naytettavaJatkuvaMenu="matMenu">
  <ng-template matMenuContent let-naytettavaJatkuva="naytettavaJatkuva">
    <app-menu-item-button (click)="avaaJatkuvaUudessaIkkunassa(naytettavaJatkuva)" actionId="Avaa uudessa ikkunassa (jatkuva)">Avaa uudessa ikkunassa</app-menu-item-button>
    <app-menu-item-button [disabled]="!(naytettavaKirjausObservable | async)" (click)="liitaJatkuva(naytettavaJatkuva)" actionId="Liitä valittuna olevaan kirjaukseen (jatkuva)">Liitä valittuna olevaan kirjaukseen</app-menu-item-button>
    <app-menu-item-button (click)="muokkaaYliajosummaa(naytettavaJatkuva)" actionId="Avasi dialogin: Muokkaa yliajosummaa (jatkuva)">Muokkaa yliajosummaa</app-menu-item-button>
    <app-menu-item-button (click)="poistaJatkuvatFlag(naytettavaJatkuva)" actionId="Avasi dialogin: Poista jatkuvista tositteista">Poista jatkuvista tositteista</app-menu-item-button>
    <app-menu-item-button (click)="paivitaJatkuvanKorostus(naytettavaJatkuva, !naytettavaJatkuva.kuitti?.kirjattavaKuitti?.korostettu && !naytettavaJatkuva.raahattava?.raahattava?.ko)" actionId="Päivitä jatkuvan korostus">{{
      !naytettavaJatkuva.kuitti?.kirjattavaKuitti?.korostettu && !naytettavaJatkuva.raahattava?.raahattava?.ko
        ? 'Korosta'
        : 'Poista
    korostus'
    }}</app-menu-item-button>
    <app-menu-item-button (click)="poistaJatkuva(naytettavaJatkuva)" actionId="Avasi dialogin: Haluatko varmasti poistaa jatkuvan">Poista</app-menu-item-button>
  </ng-template>
</mat-menu>

@if (tiedostoaPoistetaanObservable | async) {
  <div class="ei-sisaltoa">
    <div>Tositetta irroitetaan kirjauksesta.</div>
    <mat-progress-bar style="margin: 20px" mode="indeterminate"></mat-progress-bar>
  </div>
} @else {
  @if (ladataanObservable | async) {
    <div class="ei-sisaltoa">
      <div>Kirjaamattomia tositteita ladataan.</div>
      <mat-progress-bar style="margin: 20px" mode="indeterminate"></mat-progress-bar>
    </div>
  } @else {
    @if (onkoListaTyhjaObservable | async) {
      <div class="ei-sisaltoa">
        <div>Ei yhtään liittämätöntä tositetta.</div>
      </div>
    } @else {
      <div style="display: flex; flex-flow: row wrap; padding: 15px 20px 0 15px">
        <div style="flex-grow: 1; width: 100%">
          @for (maksutapaJaKuitit of maksutavatObservable | async; track maksutapaJaKuitit) {
            <app-button (click)="valitseMaksutapa(maksutapaJaKuitit.maksutapa.tunniste + '')" [dynamicClass]="{ 'valittu-maksutapa': valittuMaksutapa == maksutapaJaKuitit.maksutavanTunniste }" actionId="Kirjaamattomat: Valittu maksutapa: Maksutavan tunniste" additionalClass="kirjaamattomia-button">
              <span class="kirjaamattomia-pallura mat-elevation-z1">{{ maksutapaJaKuitit.maara }}</span>
              <span>{{ maksutapaJaKuitit.maksutapa.nimi }}</span>
              @if (maksutapaJaKuitit.korostettuja) {
                <span class="korostettuja-pallura mat-elevation-z1">{{ maksutapaJaKuitit.korostettuja }}</span>
              }
            </app-button>
          }
          @if (kirjaamattomienLaskujenMaaraObservable | async; as maara) {
            <app-button mat-button (click)="valitseMaksutapa('laskut')" [dynamicClass]="{ 'valittu-maksutapa': valittuMaksutapa == 'laskut' }" actionId="Kirjaamattomat: Valittu maksutapa: Laskut" additionalClass="kirjaamattomia-button">
              <span class="kirjaamattomia-pallura mat-elevation-z1">{{ maara.total }}</span>
              <span>Myyntilaskut</span>
              @if (maara.korostettuja) {
                <span class="korostettuja-pallura mat-elevation-z1">{{ maara.korostettuja }}</span>
              }
            </app-button>
          }
          @if (kirjaamattomienYhteisomyyntiLaskujenMaaraObservable | async; as maara) {
            <app-button (click)="valitseMaksutapa('yhteiso')" [dynamicClass]="{ 'valittu-maksutapa': valittuMaksutapa == 'yhteiso' }" actionId="Kirjaamattomat: Valittu maksutapa: Yhteisö" additionalClass="kirjaamattomia-button">
              <span class="kirjaamattomia-pallura mat-elevation-z1">{{ maara.total }}</span>
              <span>Yhteisömyyntilaskut</span>
              @if (maara.korostettuja) {
                <span class="korostettuja-pallura mat-elevation-z1">{{ maara.korostettuja }}</span>
              }
            </app-button>
          }
          @if (kirjaamattomienRaahattavienMaaraObservable | async; as maara) {
            <app-button (click)="valitseMaksutapa('raahattavat')" [dynamicClass]="{ 'valittu-maksutapa': valittuMaksutapa == 'raahattavat' }" actionId="Kirjaamattomat: Valittu maksutapa: Raahattavat" additionalClass="kirjaamattomia-button">
              <span class="kirjaamattomia-pallura mat-elevation-z1">{{ maara.total }}</span>
              <span>Omat tiedostot</span>
              @if (maara.korostettuja) {
                <span class="korostettuja-pallura mat-elevation-z1">{{ maara.korostettuja }}</span>
              }
            </app-button>
          }
          @if (jatkuvienTositteidenMaaraObservable | async; as maara) {
            <app-button (click)="valitseMaksutapa('jatkuvat')" [dynamicClass]="{ 'valittu-maksutapa': valittuMaksutapa == 'jatkuvat' }" actionId="Kirjaamattomat: Valittu maksutapa: Raahattavat" additionalClass="kirjaamattomia-button">
              <span class="kirjaamattomia-pallura mat-elevation-z1">{{ maara.total }}</span>
              <span>Toistuvat liiketapahtumat</span>
              @if (maara.korostettuja) {
                <span class="korostettuja-pallura mat-elevation-z1">{{ maara.korostettuja }}</span>
              }
            </app-button>
          }
        </div>
        <div style="width: 100%; height: 1px; background-color: darkgray; margin-top: 15px; margin-bottom: 15px"></div>
        @if (valittuMaksutapa !== 'raahattavat' && valittuMaksutapa !== 'jatkuvat') {
          <mat-checkbox (change)="naytaMyosTulevaKuukaudet($event.checked)">Näytä myös tulevat kuukaudet</mat-checkbox>
        }
        @if (valitunMaksutavanKuititObservable | async; as kuitit) {
          @for (kuitti of kuitit; track kuitti) {
            <div draggable="true" (dragstart)="aloitaKuitinRaahaaminen($event, kuitti)" (dragend)="lopetaRaahaaminen($event)" [class.korostettu]="kuitti.kirjattavaKuitti?.korostettu" class="kirjaamaton-kortti mat-elevation-z1" (click)="valitseTosite($event, kuitti)" [class.kortti-valittu]="valittuTosite === kuitti.kuitti.avain">
              @if (kuitti.kuitti.projektiAvain) {
                <div [class]="'a' + kuitti.kuitti.projektiAvain + ' kr-projekti-dot projekti-pallo'"></div>
              }
              <div class="pvm-container">
                <div class="pvm">{{ kuitti.pvm }}</div>
                <div class="summa light-blue-text">{{ kuitti.summa }}</div>
              </div>
              <div class="explanation-container">
                {{ kuitti.selite }}
              </div>
              @if (kuitti.poistetaan) {
                <mat-spinner [diameter]="22"></mat-spinner>
              } @else {
                <app-icon-button [disabled]="kuitti.tallennetaan" [matMenuTrigger]="naytettavaKuittiMenu" [matMenuTriggerData]="{ naytettavaKuitti: kuitti }" (click)="$event.stopPropagation()" actionId="Avaa kuitti menu" matIcon="more_horiz"> </app-icon-button>
              }
            </div>
          }
        }
        @if (valittuMaksutapa == 'raahattavat') {
          @for (raahattava of kirjaamattomatRaahattavatObservable | async; track raahattava) {
            <div draggable="true" (dragstart)="aloitaRaahattavanRaahaaminen($event, raahattava)" (dragend)="lopetaRaahaaminen($event)" [class.korostettu]="raahattava?.raahattava?.ko" class="kirjaamaton-kortti mat-elevation-z1" (click)="valitseRaahattava($event, raahattava)" [class.kortti-valittu]="valittuRaahattava === raahattava.avain">
              {{ raahattava.raahattava.n }}
              @if (raahattava.poistetaan) {
                <mat-spinner [diameter]="22"></mat-spinner>
              } @else {
                <app-icon-button [disabled]="raahattava.tallennetaan" [matMenuTrigger]="naytettavaRaahattavaMenu" [matMenuTriggerData]="{ naytettavaRaahattava: raahattava }" (click)="$event.stopPropagation()" actionId="Avaa raahattava menu" matIcon="more_horiz"> </app-icon-button>
              }
            </div>
          }
        }
        @if (valittuMaksutapa == 'yhteiso') {
          @for (lasku of kirjaamattomatYhteisomyyntiLaskutObservable | async; track lasku) {
            <div draggable="true" (dragstart)="aloitaLaskunRaahaaminen($event, lasku)" (dragend)="lopetaRaahaaminen($event)" [class.korostettu]="lasku?.kirjattavaLasku?.korostettu" class="kirjaamaton-kortti mat-elevation-z1" (click)="valitseLasku($event, lasku)" [class.kortti-valittu]="valittuLasku === lasku.lasku.avain">
              <div class="pvm-container">
                <div class="pvm">{{ lasku.pvm }}</div>
                <div class="summa light-blue-text">{{ lasku.summa }}</div>
              </div>
              <div class="explanation-container">
                {{ lasku.asiakas }}
              </div>
              @if (lasku.poistetaan) {
                <mat-spinner [diameter]="22"></mat-spinner>
              } @else {
                <app-icon-button [disabled]="lasku.tallennetaan" [matMenuTrigger]="naytettavaLaskuMenu" [matMenuTriggerData]="{ naytettavaLasku: lasku }" (click)="$event.stopPropagation()" actionId="Avaa yhteisömyyntilasku menu" matIcon="more_horiz"> </app-icon-button>
              }
            </div>
          }
        }
        @if (valittuMaksutapa == 'laskut') {
          @for (lasku of kirjaamattomatLaskutObservable | async; track lasku) {
            <div draggable="true" (dragstart)="aloitaLaskunRaahaaminen($event, lasku)" (dragend)="lopetaRaahaaminen($event)" [class.korostettu]="lasku?.kirjattavaLasku?.korostettu" class="kirjaamaton-kortti mat-elevation-z1" (click)="valitseLasku($event, lasku)" [class.kortti-valittu]="valittuLasku === lasku.lasku.avain">
              <div class="pvm-container">
                <div class="pvm">{{ lasku.pvm }}</div>
                <div class="summa light-blue-text">{{ lasku.summa }}</div>
              </div>
              <div class="explanation-container">
                <div>{{ lasku.asiakas }}</div>
                <div>{{ lasku.viitenumero }}</div>
              </div>
              @if (lasku.poistetaan) {
                <mat-spinner [diameter]="22"></mat-spinner>
              } @else {
                <app-icon-button [disabled]="lasku.tallennetaan" [matMenuTrigger]="naytettavaLaskuMenu" [matMenuTriggerData]="{ naytettavaLasku: lasku }" (click)="$event.stopPropagation()" actionId="Avaa lasku menu" matIcon="more_horiz"> </app-icon-button>
              }
            </div>
          }
        }
        @if (valittuMaksutapa == 'jatkuvat') {
          @for (jatkuva of jatkuvatTositteetObservable | async; track jatkuva) {
            <div draggable="true" (dragstart)="aloitaJatkuvanRaahaaminen($event, jatkuva)" (dragend)="lopetaRaahaaminen($event)" [class.korostettu]="jatkuva.kuitti?.kirjattavaKuitti?.korostettu || jatkuva.raahattava?.raahattava?.ko" class="kirjaamaton-kortti mat-elevation-z1" (click)="valitseJatkuva($event, jatkuva)" [class.kortti-valittu]="valittuJatkuva === jatkuva.avain">
              <div class="pvm-container">
                <div class="pvm">{{ jatkuva.pvm }}</div>
                <div class="summa light-blue-text">{{ jatkuva.summa }}</div>
              </div>
              <div class="explanation-container">{{ jatkuva.selite }}</div>
              @if (jatkuva.kuitti?.poistetaan || jatkuva.raahattava?.poistetaan || jatkuva.kuitti?.tallennetaan || jatkuva.raahattava?.tallennetaan) {
                <mat-spinner [diameter]="22"></mat-spinner>
              } @else {
                <app-icon-button [matMenuTrigger]="naytettavaJatkuvaMenu" [matMenuTriggerData]="{ naytettavaJatkuva: jatkuva }" (click)="$event.stopPropagation()" actionId="Avaa jatkuva menu" matIcon="more_horiz"> </app-icon-button>
              }
            </div>
          }
        }
      </div>
    }
  }
}
